import * as API from '../data/account_remittance_api';
import {signOutAction} from "./auth_actions";
import {GET_INVOICE_DETAIL} from "./account_invoice_action";

export const GET_REMITTANCE_LIST = "get_remittances";
export const GET_REMITTANCE_ESTIMATES_LIST = "get_remittance_estimate_list";
export const CLEAR_DATA = "clear_loaded_data";
export const GET_REMITTANCE_DETAIL = "get_remittance_detail";
export const GET_ESTIMATE_DETAIL = "get_remittance_estimate_detail";

export function getRemittanceList(startDate,endDate) {
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.getRemittances(startDate,endDate);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_REMITTANCE_LIST,
                payload: response.data
            });
        }
    };
}

export function getRemittanceEstimates() {
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.getRemittanceEstimateList();
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_REMITTANCE_ESTIMATES_LIST,
                payload: response.data
            });
        }
    };
}


export function getRemittanceDetails(id) {
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.getRemittanceDetail(id);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_REMITTANCE_DETAIL,
                payload: response.data.remittance
            });
        }
    };
}

export function getEstimateDetails(id) {
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.getEstimateDetails(id);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({
                type: GET_ESTIMATE_DETAIL,
                payload: response.data['remittance_estimate']
            });
        }
    };
}

export function changeRemittanceStatus(status,remittanceId,successCallBack) {
    return async (dispatch) => {
        const response = await API.changeRemittanceStatus(status);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch(getRemittanceDetails(remittanceId));
            successCallBack(response.data);
        }
    };
}



export function updateAdjustment(formData,actionType,successCallBack,estimateId) {
    return async (dispatch) => {
        const response = await API.updateAdjustment(formData,actionType);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response.data);
        }
        dispatch(getEstimateDetails(estimateId))
    };
}


export function deleteAdjustment(adjustmentId,successCallBack,estimateId){
    return async (dispatch) => {
        const response = await API.deleteAdjustment(adjustmentId);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response.data);
        }
        dispatch(getEstimateDetails(estimateId))
    }
}

export function regenerateRemittance(remittanceId,successCallBack){
    return async (dispatch) => {
        dispatch({
            type:CLEAR_DATA
        });
        const response = await API.regenerateRemittance(remittanceId);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response.data);
            dispatch({
                type: GET_REMITTANCE_DETAIL,
                payload: response.data.remittance
            });
        }
    }
}

export function sendRemittanceMail (remittanceId,successCallBack){
    return async (dispatch) => {
        const response = await API.sendRemittanceMail(remittanceId);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response.data);
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/account_remittance_action.js